import { orgFromFirestore } from '@parallel-fluidics/shared/models/organizations';
import {
  collection,
  getDocs,
  getFirestore,
  or,
  query,
  where,
} from 'firebase/firestore';

const MAX_DOMAIN_DISJUNCTIONS = 29;

export default async function getOrgsByNameOrDomain({ domains = [], name = '' }) {
  const filteredDomains = [...new Set(
    domains
      .map((domain) => domain.trim())
      .filter(Boolean),
  )].slice(0, MAX_DOMAIN_DISJUNCTIONS);
  const nameLowercase = name.trim().toLowerCase();
  const orCondition = [];
  if (filteredDomains.length > 0) {
    orCondition.push(where('domains', 'array-contains-any', filteredDomains));
  }
  if (nameLowercase.length > 0) {
    orCondition.push(where('name_lowercase', '==', nameLowercase));
  }
  if (!orCondition.length) return [];
  const orgsSnapshot = await getDocs(
    query(
      collection(getFirestore(), 'organizations'),
      or(
        ...orCondition,
      ),
    ),
  );
  if (!orgsSnapshot.empty) {
    return orgsSnapshot.docs.map((orgDoc) => orgFromFirestore(orgDoc));
  }
  return [];
}
